// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3k99g","title":"Info_title__2LKHB","links":"Info_links__1hFMG","link":"Info_link__2vzDh","logo":"Info_logo__CAPFU"};